import { render, staticRenderFns } from "./CardProduct.vue?vue&type=template&id=6304321d&scoped=true&"
import script from "./CardProduct.vue?vue&type=script&lang=js&"
export * from "./CardProduct.vue?vue&type=script&lang=js&"
import style0 from "./CardProduct.vue?vue&type=style&index=0&id=6304321d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6304321d",
  null
  
)

export default component.exports